import React from 'react';
import { cn } from '../cn';
import { accentStyle } from './accents';
/** The viewer's browser timezone (IANA), resolved once at module load. */
export const BROWSER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
/**
 * Default reporting timezone vs the viewer's local timezone. Switching zones
 * shifts the period windows, so the numbers can legitimately differ.
 */
export const TimezoneToggle = ({ useLocal, onChange, defaultLabel = 'Report time', accent = 'orange', className, }) => {
    const a = accentStyle(accent);
    const options = [
        { local: false, label: defaultLabel, title: 'Default reporting timezone' },
        { local: true, label: 'My time', title: BROWSER_TIMEZONE },
    ];
    return (React.createElement("div", { className: cn('inline-flex rounded-xl border p-1', a.segmentContainer, className) }, options.map((opt) => (React.createElement("button", { key: opt.label, type: "button", title: opt.title, onClick: () => onChange(opt.local), className: cn('rounded-lg px-3 py-1.5 text-sm font-medium transition-colors', useLocal === opt.local ? a.segmentActive : a.segmentInactive) }, opt.label)))));
};
export default TimezoneToggle;
